"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompareResult = void 0;
exports.compareData = compareData;
/**
 * Porównuje dane uzywając schematu, zwraca CompareResult zawierający wynik porównania i listę róźnic
 * @param firstItem pierwszy element do porównania
 * @param secondItem drugi element do porównania
 */
function compareData(schema, firstItem, secondItem, compareArraySize) {
    const result = new CompareResult();
    _compareData(schema, firstItem, secondItem, '', result, compareArraySize);
    return result;
}
class CompareResult {
    constructor() {
        this.equal = true;
        this.diff = [];
    }
}
exports.CompareResult = CompareResult;
function _compareData(schema, firstItem, secondItem, path, result, compareArraySize) {
    if (schema.type === 'object') {
        if (typeof firstItem !== 'object') {
            firstItem = {};
        }
        if (typeof secondItem !== 'object') {
            secondItem = {};
        }
        if (schema.properties) {
            for (const key in schema.properties) {
                const element = schema.properties[key];
                const value1 = firstItem[key];
                const value2 = secondItem[key];
                _compareData(element, value1, value2, path === '' ? key : path + '.' + key, result, compareArraySize);
            }
        }
    }
    else if (schema.type === 'array') {
        const items = schema.items;
        if (items) {
            if (!Array.isArray(firstItem)) {
                firstItem = [];
            }
            if (!Array.isArray(secondItem)) {
                secondItem = [];
            }
            // if (Array.isArray(firstItem) && Array.isArray(secondItem)) {
            if (firstItem.length !== secondItem.length && compareArraySize) {
                result.equal = false;
                result.diff.push({
                    path,
                    type: 'arrayLength',
                    value: [firstItem.length, secondItem.length],
                    schema
                });
            }
            const mlength = Math.max(firstItem.length, secondItem.length);
            for (let i = 0; i < mlength; i++) {
                _compareData(items, firstItem[i], secondItem[i], path + '[' + i + ']', result, compareArraySize);
            }
        }
        // }
    }
    else {
        if (firstItem === undefined && secondItem === undefined) {
            return;
        }
        if (firstItem === undefined || secondItem === undefined) {
            result.equal = false;
            result.diff.push({
                path,
                type: 'value',
                value: [firstItem, secondItem],
                schema
            });
            return;
        }
        if ('' + firstItem !== '' + secondItem) {
            result.equal = false;
            result.diff.push({
                path,
                type: 'value',
                value: [firstItem, secondItem],
                schema
            });
            return;
        }
    }
}
exports.default = compareData;
//# sourceMappingURL=compareData.js.map